import React, { useState } from "react";
import "./RepDetailView.css";

function RepDetailView({ rep, onBack }) {
  const [activeTab, setActiveTab] = useState("History");

  const tabConfig = ["History", "Offer", "Activity"];

  return (
    <div className="rep-detail-view">
      {/* Header */}
      <div className="rep-detail-header">
        <button className="rep-detail-back-btn" onClick={onBack}>
          <span className="material-icons">arrow_back</span>
          <span>Back to Dashboard</span>
        </button>
      </div>

      {/* Contact Info Card */}
      <div className="rep-contact-card">
        <div className="rep-contact-left">
          <div className="rep-contact-name-section">
            <h1 className="rep-contact-name">
              {rep.first_name} {rep.last_name}
            </h1>
            <span
              className={`rep-status-badge ${rep.verified ? "verified" : "pending"}`}
            >
              {rep.verified ? "Verified" : "Pending"}
            </span>
          </div>
          <div className="rep-contact-details">
            <div className="rep-contact-item">
              <span className="material-icons">phone</span>
              <span>{rep.phone || "N/A"}</span>
            </div>
            <div className="rep-contact-item">
              <span className="material-icons">email</span>
              <span>{rep.email || "N/A"}</span>
            </div>
            <div className="rep-contact-item">
              <span>Role:</span>
              <span className="rep-role-name">{rep.role_name || "N/A"}</span>
            </div>
          </div>
        </div>
        <div className="rep-contact-right">
          <button className="btn btn-primary btn-send-offer">Send Offer</button>
          <button className="btn btn-ghost-secondary btn-icon-only">
            <span className="material-icons">more_vert</span>
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="rep-detail-tabs">
        {tabConfig.map(tab => (
          <button
            key={tab}
            className={`rep-detail-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="rep-detail-content">
        {activeTab === "History" && (
          <div className="rep-tab-panel">
            <div className="empty-state">
              <div className="empty-state-icon">
                <span className="material-icons">event</span>
              </div>
              <h3>No meetings scheduled</h3>
              <p>Add your first meeting to get started</p>
              <button className="btn btn-outline-primary">
                Schedule Meeting
              </button>
            </div>
          </div>
        )}

        {activeTab === "Offer" && (
          <div className="rep-tab-panel">
            <div className="empty-state">
              <div className="empty-state-icon">
                <span className="material-icons">description</span>
              </div>
              <h3>No compensation plan set</h3>
              <p>Configure the compensation plan for this rep</p>
              <button className="btn btn-outline-primary">
                Configure Compensation
              </button>
            </div>
          </div>
        )}

        {activeTab === "Activity" && (
          <div className="rep-tab-panel">
            <div className="empty-state">
              <div className="empty-state-icon">
                <span className="material-icons">school</span>
              </div>
              <h3>No training activity</h3>
              <p>
                Training activity will appear here once the rep completes
                courses
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default RepDetailView;
